<template>
  <div id="appDownload-view">
    <img src="../../assets/images/appDownload.png"/>
    <div v-show="isAndroid" v-on:click="download('Android')">Android下载</div>
    <div v-show="isiOS" v-on:click="download('iPhone')">iPhone下载</div>
  </div>
</template>

<script>
if (typeof window !== 'undefined') {
  require('../../assets/js/flexible.js')
}
export default{
  data () {
    return {
      isAndroid: null,
      isiOS: null
    }
  },
  created () {
    /* eslint-disable */
    if (typeof window !== 'undefined') {
      let u = navigator.userAgent
      if (!!u.match(/AppleWebKit.*Mobile.*/)) { /* 是否为移动终端 */
        this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
        this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      } else {
        this.$router.replace({
          name: 'downloadApp'
        })
      }
    }
    /* eslint-disable */
  },
  methods: {
    download (type) {
      if (typeof window !== 'undefined') {
        window.open(type === 'Android' ? 'https://www.puhuilicai.com/apis/web-server/commonFiles/apk/puhuilicai.apk' : 'https://itunes.apple.com/cn/app/pu-hui-li-cai-quan-tou-ming/id1020104122', '_blank')
      }
    }
  }
}
</script>

<style lang="less">
#appDownload-view{
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  img{
    width: 100%;
  }
  div{
    width: 6rem;
    height: 0.88rem;
    border-radius: 0.04rem;
    background: linear-gradient(-52deg, rgb(247,81,65) 0%,  rgb(240,96,46) 100%);
    box-shadow: 0.04rem 0.08rem 0.4rem 0px rgba( 237, 65, 48 0.39);
    font-size: 0.32rem;
    color: #fff;
    box-sizing: border-box;
    line-height: 0.88rem;
    text-align: center;
    position: absolute;
    bottom: 2.95rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/account/appDownload.vue